import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Table } from 'reactstrap';

import AdminFiltersListHeader from './ListHeader';
import AdminFiltersListItem from './ListItem';

import withDragAndDropContext from '../../../helpers/withDragAndDropContext';

const AdminFiltersList = ({
  filters,
  saving,
  moveFilter,
  handleVisibilitySwitch,
  handleAdminsOnlySwitch,
  handleOpenByDefaultSwitch,
}) => {
  const [dragging, setDragging] = useState(false);
  const [openMap, setOpenMap] = useState({});

  const toggleCollapse = key => {
    setOpenMap(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    setOpenMap(prev => {
      const updated = { ...prev };

      filters.forEach(filter => {
        if (updated[filter.key] === undefined) {
          updated[filter.key] = true;
        }
      });

      return updated;
    });
  }, [filters]);

  return (
    <Table className="users-list filters-list" responsive>
      <thead>
        <AdminFiltersListHeader />
      </thead>
      <tbody className={classnames({ dragging })}>
        {filters.map(filter => {
          const isOpen = openMap[filter.key];

          return (
            <React.Fragment key={filter.key}>
              <AdminFiltersListItem
                index={filter.key}
                filter={filter}
                parentKey={null}
                canDrag={true}
                moveFilter={moveFilter}
                setDragging={setDragging}
                saving={saving}
                handleVisibilitySwitch={handleVisibilitySwitch}
                handleAdminsOnlySwitch={handleAdminsOnlySwitch}
                handleOpenByDefaultSwitch={handleOpenByDefaultSwitch}
                collapseOpen={isOpen}
                handleCollapseOpen={() => toggleCollapse(filter.key)}
              />
              {filter.children && isOpen && filter.children.map(child => (
                <AdminFiltersListItem
                  key={child.key}
                  index={child.key}
                  filter={child}
                  parentKey={filter.key}
                  canDrag={true}
                  moveFilter={moveFilter}
                  setDragging={setDragging}
                  saving={saving}
                  handleVisibilitySwitch={handleVisibilitySwitch}
                  handleAdminsOnlySwitch={handleAdminsOnlySwitch}
                  handleOpenByDefaultSwitch={handleOpenByDefaultSwitch}
                />
              ))}
            </React.Fragment>
          );
        })}
      </tbody>
    </Table>
  );
};

AdminFiltersList.propTypes = {
  filters: PropTypes.array.isRequired,
  saving: PropTypes.bool.isRequired,
  moveFilter: PropTypes.func.isRequired,
  handleVisibilitySwitch: PropTypes.func.isRequired,
  handleAdminsOnlySwitch: PropTypes.func.isRequired,
  handleOpenByDefaultSwitch: PropTypes.func.isRequired,
};

export default withDragAndDropContext(AdminFiltersList);
